import React, { Component } from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

const Footer = () => {
  return (
    <>
    <div className={getTheme('footer')}>
      <div className="footer-container">
        <div className="footer-row">
          <div className="col-md-4">
            <div className="footer-content">
              <h4 className={getTheme('footer-h4')}>{translate('Firma')}</h4>

              <div className="footer-inline">
                <h5 className="footer-h5">{translate('Nazwa:')}</h5>
                <p className="footer-text">Filipek - Motors Sp. z o.o.</p>
              </div>
              <div className="footer-inline">
                <h5 className="footer-h5">NIP:</h5>
                <p className="footer-text">9462685876</p>
              </div>
              <div className="footer-inline">
                <h5 className="footer-h5">KRS:</h5>
                <p className="footer-text">0000767346</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="footer-content">
              <h4 className={getTheme('footer-h4')}>E-mail</h4>

              <div className="footer-inline">
                <h5 className="footer-h5">{translate('Prezes Zarządu:')}</h5>
                <p className="footer-text">k.dubicki@pollub.pl</p>
              </div>
              <div className="footer-inline">
                <h5 className="footer-h5">
                  {translate('Udziałowiec większościowy:')}
                </h5>
                <p className="footer-text">p.filipek@pollub.pl</p>
              </div>
              <div className="footer-inline">
                <h5 className="footer-h5">
                  {translate('Udziałowiec mniejszościowy:')}
                </h5>
                <p className="footer-text">g.klosowski@pollub.pl</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="footer-content">
              <h4 className={getTheme('footer-h4')}>
                {translate('Lokalizacja')}
              </h4>

              <div className="footer-inline">
                <h5 className="footer-h5">{translate('Adres siedziby:')}</h5>
                <p className="footer-text">Lublin 20-618</p>
                <br />
                <p className="footer-text">ul. Nadbystrzycka 38H</p>
              </div>
              <div className='footer-inline'>
                <h5 className='footer-h5'>
                  {translate('Miejsce realizacji projektu:')}
                </h5>
                <p className='footer-text'>20-618 Lublin</p>
                <p className='footer-text'>ul. Skromna 5 Lokal: H10</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          <div className='autors-container'>
          <div className='footer-autors'>
            <p>
              <b> Authors: </b>
              <a href='https://www.linkedin.com/in/kamil-piwko-b49795161'>
                Kamil Piwko{', '}
              </a>
              <a href='https://www.linkedin.com/in/gaweł-gawałkiewicz-06b778143'>
                Gaweł Gawałkiewicz{', '}
              </a>
              <a href=''> Przemysław Ciołek </a>
            </p>
          </div>
        </div>
        </>
  );
};

export default Footer;
